import { useDispatch } from 'react-redux'
import { useState } from 'react'

import {
  actionFetchClients,
  actionUpdateClient,
  actionResetClients,
} from 'modules/Referral/ReferralClients/actions'

export const useReferralClients = () => {
  const [fetchClientsProgress, setFetchClientsProgress] = useState(false)
  const [fetchClientsFinished, setFetchClientsFinished] = useState(false)
  const [fetchClientsFailed, setFetchClientsFailed] = useState(false)

  const dispatch = useDispatch()

  const fetchClients = (props) =>
    new Promise((resolve, reject) => {
      setFetchClientsProgress(true)
      setFetchClientsFailed(false)
      setFetchClientsFinished(false)
      dispatch(actionFetchClients({ ...props, meta: { resolve, reject } }))
    })
      .catch(() => setFetchClientsFailed(true))
      .finally(() => {
        setFetchClientsProgress(false)
        setFetchClientsFinished(true)
      })

  fetchClients.progress = fetchClientsProgress
  fetchClients.finished = fetchClientsFinished
  fetchClients.failed = fetchClientsFailed

  const updateClient = (props) =>
    new Promise((resolve, reject) =>
      dispatch(actionUpdateClient({ ...props, meta: { resolve, reject } })),
    )

  const resetClients = () => dispatch(actionResetClients())

  return { fetchClients, updateClient, resetClients }
}
